<template>
  <f-button
    v-bind="$attrs"
    v-on="$listeners"
    :style="computedStyle"
  >
    <slot></slot>
  </f-button>
</template>

<script>
export default {
  name: 'AskQuestionCustomButton',
  props: {
    color: {
      type: String,
      default: '#5cbab6'
    },
    textColor: {
      type: String,
      default: '#FFF'
    }
  },
  inheritAttrs: false,
  methods: {
    getColorBrightness(color) {
      try {
        // Create a temporary DOM element
        const div = document.createElement('div');
        div.style.color = color;
        document.body.appendChild(div);

        // Get the computed color (browser converts to rgb format)
        const computedColor = window.getComputedStyle(div).color;
        document.body.removeChild(div);

        // Parse rgb(r, g, b) or rgba(r, g, b, a)
        const rgbMatch = computedColor.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
        if (rgbMatch) {
          const r = parseInt(rgbMatch[1]);
          const g = parseInt(rgbMatch[2]);
          const b = parseInt(rgbMatch[3]);

          // Calculate relative luminance
          return (r * 0.299 + g * 0.587 + b * 0.114);
        }

        // Fallback if parsing fails
        return 128;
      } catch (error) {
        // Fallback for any errors
        return 128;
      }
    }
  },
  computed: {
    finalTextColor() {
      // Only calculate text color for primary buttons
      if (this.$attrs.type !== 'primary') return null;

      // Always use the textColor prop (default #FFF or user-specified)
      if (this.textColor && this.textColor.trim()) {
        return this.textColor.trim();
      }

      // Final fallback (should rarely be used)
      return '#FFF';
    },
    computedStyle() {
      const providedStyle = this.$attrs.style || {};

      // Only apply custom color to primary buttons
      if (this.$attrs.type === 'primary') {
        return {
          ...providedStyle,
          backgroundColor: this.color,
          borderColor: this.color,
          color: this.finalTextColor
        };
      }

      return providedStyle;
    }
  }
}
</script>